import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {LoginComponent} from "./login.component";
import {LoginRoutingModule} from "./login-routing.module";
import {NgHcaptchaModule} from "ng-hcaptcha";
import {SharedModule} from "../shared/shared.module";
import {TranslateDirective, TranslatePipe} from "@ngx-translate/core";
import {MatTooltipModule} from "@angular/material/tooltip";
import {GenderSelectComponent} from "../shared/gender-select/gender-select.component";
import {RECAPTCHA_LOADER_OPTIONS, RecaptchaModule} from "ng-recaptcha-2";


@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        CommonModule,
        LoginRoutingModule,
        SharedModule,

        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatSnackBarModule,
        MatCardModule,
        MatCheckboxModule,
        MatDialogModule,

        NgHcaptchaModule.forRoot({
            siteKey: '3d96364b-9eed-430d-b605-04909fe0c1dd'
        }),
        RecaptchaModule,
        TranslatePipe, TranslateDirective,
        MatTooltipModule,
        GenderSelectComponent,
        NgHcaptchaModule,
    ],
    providers: [
        {
            provide: RECAPTCHA_LOADER_OPTIONS,
            useValue: {
                onBeforeLoad(_url) {
                    return {
                        url: new URL("https://www.recaptcha.net/recaptcha/api.js"), // use recaptcha.net script source for some of our users
                    };
                },
            },
        },
    ],
})
export class LoginModule {
}
